<template>
  <div class="openid-modify">
    <OpenidForm operate="modify" />
  </div>
</template>

<script>
import OpenidForm from './OpenidForm'
export default {
  name: 'openid-modify',

  components: {
    OpenidForm
  }
}
</script>

